@if (invalid$ | async; as invalid) {
  @if (suggested$ | async; as suggested) {
    <p-accordion
      [multiple]="true"
      rememberState
      [rememberStateGroupKey]="props.rememberStateGroupKey || 'default'"
      [rememberStateKey]="props.rememberStateKey || props.label"
      expandIcon="pi pi-chevron-down"
      collapseIcon="pi pi-chevron-up"
      [dt]="props.dt?.components?.accordion"
    >
      @for (tab of field.fieldGroup; track tab) {
        @if (!tab.hide) {
          <p-accordion-panel
            [value]="$index"
            [dt]="props.dt?.components?.accordion?.panel"
            [attr.data-testid]="'formly-accordion-panel-' + tab.props.label"
          >
            <p-accordion-header
              [dt]="props.dt?.components?.accordion?.header"
              [class.text-danger]="invalid[$index]"
              [class.text-highlight]="suggested[$index]"
              [class.text-ai-fill]="(filledByAI$ | async)?.[$index]"
            >
              {{ tab.props.label }}
              @if (showDebugInfo) {
                @if (tabErrorsTooltip($index); as tooltip) {
                  <i class="pi pi-info-circle ms-1 text-sm cursor-help" [pTooltip]="tooltip" [escape]="false" tooltipPosition="right"></i>
                }
              }
            </p-accordion-header>

            <p-accordion-content [dt]="props.dt?.components?.accordion?.content">
              <formly-field [field]="tab" />
            </p-accordion-content>
          </p-accordion-panel>
        }
      }
    </p-accordion>
  }
}

@if (!props.readonly && uploadMenu?.length) {
  <div class="max-mobile:col mobile:row border-t-1 border-surface-border p-4">
    @if (uploadMenu.length > 1) {
      <new-ui-button
        [dt]="props.dt?.components?.button"
        class="max-mobile:*:w-full"
        icon="icon-[mi--document-file-upload-bottom-center]"
        severity="secondary"
        [label]="props.uploadLabel"
        (onClick)="menu.toggle($event)"
      />

      <p-menu #menu [popup]="true" [model]="uploadMenu" appendTo="body" [dt]="props.dt?.components?.menu" />
    } @else {
      <new-ui-button
        [dt]="props.dt?.components?.button"
        class="max-mobile:*:w-full"
        icon="icon-[mi--document-file-upload-bottom-center]"
        severity="secondary"
        [label]="props.uploadLabel"
        (onClick)="openUploadDialog(props.uploadTypes[0])"
      />
    }
  </div>
}
